/**
 * Controls that own Enter themselves, so a dialog that submits on Enter must not take it
 * from them.
 *
 * Buttons and links have to do what they say (Back, Cancel, the date trigger), a multi-line
 * field needs it for its newline, and a COMBOBOX uses it to open and to confirm a choice —
 * PrimeVue Selects focus a `role="combobox"` div, not a button.
 */
const OWNS_ENTER = 'button, a, textarea, select, [role="combobox"], [role="listbox"], [role="option"]';

/** True when an Enter keydown came from a plain field, which is the only place a dialog may claim it. */
export function enterFromField(event: KeyboardEvent): boolean {
    return !(event.target as HTMLElement | null)?.closest(OWNS_ENTER);
}
